import React, { useEffect, useState, useRef } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import Select from "react-select";
import Sidebar from "../Sidebar";

export default function ImageForm() {
  const [files, setFiles] = useState([]);
  const [filenames, setFilenames] = useState([]);
  const [uploadedFiles, setUploadedFiles] = useState([]);
  const [message, setMessage] = useState("");
  const [imagePreviews, setImagePreviews] = useState([]);
  const [jsonObject, setJsonObject] = useState({
    district: "",
    district_id: 0,
    date: "",
    images: [],
    year: "",
    comment: "",
    crop: "",
  });

  const cRef = useRef(null);
  const dRef = useRef(null);
  const yRef = useRef(null);

  // for options
  const [options2, setOptions2] = useState([]);
  const [selectedOptions, setSelectedOptions] = useState("");
  const [selectedOptions2, setSelectedOptions2] = useState("");
  const [options, setOptions] = useState([]);

  //Navigate
  const navigate = useNavigate();

  useEffect(() => {
    const crickets = options;
    const searchTerm = crickets.map((cricket) => ({
      value: cricket.name,
      label: cricket.name,
    }));
    setOptions2(searchTerm);
  }, [options]);

  const ferrit = async () => {
    const token = sessionStorage.getItem("token");
    const response = await fetch(
      `${process.env.REACT_APP_API_URL}/getDistrictsForCropCondition`,
      {
        headers: {
          "x-access-token": token,
        },
      }
    );
    const data = await response.json();
    setOptions(data);
    // console.log(data);
  };

  useEffect(() => {
    ferrit();
  }, []);

  const organizeImagesIntoRows = () => {
    const rows = [];
    for (let i = 0; i < imagePreviews.length; i += 3) {
      const row = imagePreviews.slice(i, i + 3);
      rows.push(row);
    }
    return rows;
  };

  const today = new Date().toISOString().split("T")[0];

  const districtHandler = (item) => {
    const selectedName = item;
    const selected = options.find((option) => option.name === selectedName);
    console.log("selected in district handler:",selected)
    setJsonObject({
      ...jsonObject,
      district: selectedName,
      district_id: selected.value,
    });
  };

console.log("Json Object:",jsonObject)

  const addImageInput = () => {
    const input = document.createElement("input");
    input.type = "file";
    input.className = "custom-file-input";
    input.required = true;
    input.multiple = true;
    input.addEventListener("change", onChange);
    input.click();
  };

  const onDeleteImage = (index) => {
    const newFiles = [...files];
    const newFilenames = [...filenames];
    const newImagePreviews = [...imagePreviews];
    newFiles.splice(index, 1);
    newFilenames.splice(index, 1);
    newImagePreviews.splice(index, 1);
    setFiles(newFiles);
    setFilenames(newFilenames);
    setImagePreviews(newImagePreviews);
  };

  const onSubmit = async (e) => {
    e.preventDefault();
    const formData = new FormData();
    
    // Convert district_id to integer before stringifying
    const jsonObjectToSend = {
      ...jsonObject,
      district_id: parseInt(jsonObject.district_id)
    };
    
    formData.append("jsonData", JSON.stringify(jsonObjectToSend));
    files.forEach((file) => formData.append("files", file)); // Add all files
    try {
      const res = await axios.post(
        `${process.env.REACT_APP_API_URL}/uploadCropImages`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );

      const newUploadedFiles = res.data;
      setUploadedFiles(newUploadedFiles);
      setMessage("Files Uploaded");
      navigate("/images");
    } catch (err) {
      if (err.response && err.response.status === 500) {
        setMessage("There was a problem with the server");
      } else if (err.response) {
        setMessage(err.response.data.msg);
      }
    }
  };

  const onChange = (e) => {
    const selectedFiles = Array.from(e.target.files); // Multiple file selection
    const selectedFilenames = selectedFiles.map((file) => file.name);

    const newImageObjects = selectedFiles.map((file) => ({
      // img_url: `${process.env.REACT_APP_API_URL}/uploads/${file.name}`,
      img_url: `https://admin.par.com.pk/api/uploads/compressed_${file.name}`,
      // img_url: `https://new.par.com.pk/uploads/c${file.name}`,
      img_path: "/uploads/",
    }));

    setFiles([...files, ...selectedFiles]);
    setFilenames([...filenames, ...selectedFilenames]);

    setJsonObject((prevObject) => ({
      ...prevObject,
      images: [...prevObject.images, ...newImageObjects],
    }));

    const previews = selectedFiles.map((file) => {
      const reader = new FileReader();
      return new Promise((resolve) => {
        reader.onload = (e) => resolve(e.target.result);
        reader.readAsDataURL(file);
      });
    });

    Promise.all(previews).then((previewData) => {
      setImagePreviews([...imagePreviews, ...previewData]);
    });
  };

  return (
    <>
      <div className="sidebar">
        <Sidebar />
      </div>
      <div id="tabler">
        <form onSubmit={onSubmit} enctype="multipart/form-data">
          <h1>Add Crop Images</h1>
          <div className="row">
            <div className="col-md-3">
              <label htmlFor="num-value" className="form-label">
                Date
              </label>
              <div className="input-group input-group-md mb-3">
                <input
                  type="date"
                  id="num-value"
                  className="form-control"
                  required
                  value={jsonObject.date || ""}
                  onChange={(e) =>
                    setJsonObject({ ...jsonObject, date: e.target.value })
                  }
                />
              </div>
            </div>

            <div className="col-md-3">
              <label htmlFor="inputGroupSelect07" className="form-label">
                District
              </label>
              <Select
                options={options2}
                value={selectedOptions}
                placeholder="district"
                onChange={(stat) => {
                  setSelectedOptions(stat);
                  districtHandler(stat.value);
                }}
                isSearchable
                ref={dRef}
                noOptionsMessage={() => "Not found"}
                required
              />
            </div>

            <div className="col-md-3">
              <label htmlFor="num-value" className="form-label">
                Year
              </label>
              <div className="input-group mb-3">
                <select
                  className="form-select"
                  id="num-value"
                  ref={yRef}
                  onChange={(e) =>
                    setJsonObject({ ...jsonObject, year: e.target.value })
                  }
                  required
                >
                  <option value="">Select year</option>
                  <option value="2025-26">2025-26</option>
                  <option value="2024-25">2024-25</option>
                  <option value="2023-24">2023-24</option>
                  <option value="2022-23">2022-23</option>
                  <option value="2021-22">2021-22</option>
                  <option value="2020-21">2020-21</option>
                  <option value="2019-20">2019-20</option>
                </select>
              </div>
            </div>

            <div className="col-md-3">
              <label htmlFor="num-value" className="form-label">
                Crop
              </label>
              <div className="input-group mb-3">
                <select
                  className="form-select"
                  id="num-value"
                  ref={yRef}
                  onChange={(e) =>
                    setJsonObject({ ...jsonObject, crop: e.target.value })
                  }
                  required
                >
                  <option value="">Select crop</option>
                  <option value="cotton">cotton</option>
                  <option value="sugar">sugar</option>
                  <option value="wheat">wheat</option>
                  <option value="maize">maize</option>
                  <option value="rice">rice</option>
                  <option value="edible-oils">edible-oils</option>
                  <option value="spices">spices</option>
                </select>
              </div>
            </div>
          </div>

          <div className="mb-3">
            <label htmlFor="comment" className="form-label">
              Comment
            </label>
            <textarea
              className="form-control"
              // required
              id="comment"
              onChange={(e) =>
                setJsonObject({ ...jsonObject, comment: e.target.value })
              }
              maxLength={160}
              rows="3"
            />
          </div>

          {filenames.map((filename, index) => (
            <div key={index} className="custom-file mb-4">
              <input
                type="file"
                className="custom-file-input"
                id={`customFile-${index}`}
                style={{ display: "none" }}
              />
              <label
                className="custom-file-label"
                htmlFor={`customFile-${index}`}
              >
                {filename}
              </label>
              <button
                type="button"
                onClick={() => onDeleteImage(index)}
                style={{
                  color: "white",
                  backgroundColor: "red",
                  border: "1px solid red",
                  borderRadius: "3px",
                }}
              >
                x
              </button>
            </div>
          ))}

          {imagePreviews.length > 0 && (
            <div className="image-preview">
              {organizeImagesIntoRows().map((row, rowIndex) => (
                <div key={rowIndex} className="image-row">
                  {row.map((imagePreview, index) => (
                    <div key={index} className="image-column">
                      {/* <img src={imagePreview} alt="preview" /> */}
                    </div>
                  ))}
                </div>
              ))}
            </div>
          )}

          <div className="mb-3">
            <button
              type="button"
              onClick={addImageInput}
              className="btn btn-primary btn-block mt-4"
            >
              Add Image(s)
            </button>
          </div>
          <button
            type="submit"
            value="Upload"
            className="btn btn-danger btn-block mt-4 "
          >
            Upload
          </button>
        </form>

        {message ? <h3>{message}</h3> : null}
      </div>
    </>
  );
}
